module.exports = {
	"id": "UA",
	"name": "Ukraine",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.260594,
			"5": 0.170734,
			"6": 0.152762,
			"7": 0.143776,
			"8": 0.071888,
			"9": 0.143776,
			"10": 0.143776,
			"11": 0.197692,
			"12": 0.215664,
			"13": 0.188706,
			"14": 0.251608,
			"15": 0.323496,
			"16": 0.296538,
			"17": 0.386398,
			"18": 0.4493,
			"19": 0.341468,
			"20": 0.332482,
			"21": 0.58409,
			"22": 0.40437,
			"23": 0.4493,
			"24": 0.40437,
			"25": 0.332482,
			"26": 0.323496,
			"27": 0.341468,
			"28": 0.17972,
			"29": 0.098846,
			"30": 0.071888,
			"31": 0.116818,
			"32": 0.080874,
			"33": 0.116818,
			"34": 0.098846,
			"35": 0.233636,
			"36": 0.098846,
			"37": 0.125804,
			"38": 0.197692,
			"39": 0.377412,
			"40": 0.548146,
			"41": 0.278566,
			"42": 0.26958,
			"43": 0.341468,
			"44": 0.035944,
			"45": 0.071888,
			"46": 0.062902,
			"47": 0.08986,
			"48": 0.17972,
			"49": 2.255486,
			"50": 0.197692,
			"51": 0.880628,
			"52": 0.503216,
			"53": 19.508606,
			"54": 5.643208,
			"55": 0.197692,
			"56": 0.071888,
			"57": null
		},
		"firefox": {
			"2": 0.278566,
			"3": 0.727866,
			"4": 0.197692,
			"5": 0.080874,
			"6": 0.062902,
			"7": 0.035944,
			"8": 0.062902,
			"9": 0.062902,
			"10": 0.116818,
			"11": 0.071888,
			"12": 0.071888,
			"13": 0.071888,
			"14": 0.098846,
			"15": 0.143776,
			"16": 0.116818,
			"17": 0.071888,
			"18": 0.062902,
			"19": 0.098846,
			"20": 0.116818,
			"21": 0.107832,
			"22": 0.062902,
			"23": 0.080874,
			"24": 0.098846,
			"25": 0.08986,
			"26": 0.053916,
			"27": 0.026958,
			"28": 0.053916,
			"29": 0.026958,
			"30": 0.04493,
			"31": 0.062902,
			"32": 0.08986,
			"33": 0.107832,
			"34": 0.125804,
			"35": 0.22465,
			"36": 0.17972,
			"37": 0.035944,
			"38": 0.143776,
			"39": 0.053916,
			"40": 0.035944,
			"41": 0.035944,
			"42": 0.035944,
			"43": 0.170734,
			"44": 0.053916,
			"45": 0.17972,
			"46": 0.197692,
			"47": 0.620034,
			"48": 0.323496,
			"49": 5.364642,
			"50": 0.04493,
			"51": 0.017972,
			"52": null,
			"3.5": 1.338914,
			"3.6": 3.50454
		},
		"opera": {
			"9": null,
			"11": 0.197692,
			"12": 1.464718,
			"15": 0.04493,
			"16": 0.053916,
			"17": 0.04493,
			"18": 0.107832,
			"19": 0.062902,
			"20": 0.170734,
			"21": 0.080874,
			"22": 0.035944,
			"23": 0.04493,
			"24": 0.08986,
			"25": 0.098846,
			"26": 0.098846,
			"27": 0.71888,
			"28": 0.053916,
			"29": 0.062902,
			"30": 0.035944,
			"31": 0.017972,
			"32": 0.017972,
			"33": 0.017972,
			"34": 0.026958,
			"35": 0.04493,
			"36": 0.530174,
			"37": 0.143776,
			"38": 0.17972,
			"39": 0.08986,
			"40": 3.585414,
			"41": 0.575104,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.170734,
			"10.5": 0.197692,
			"10.6": 0.593076,
			"11.1": 0.188706,
			"11.5": 0.323496,
			"11.6": 1.231082,
			"12.1": 5.005202
		},
		"safari": {
			"0": null,
			"4": 0.557132,
			"5": 0.835698,
			"6": 0.13479,
			"7": 0.071888,
			"8": 0.098846,
			"9": 0.062902,
			"10": 0.638006,
			"3.1": 0.098846,
			"3.2": 0.04493,
			"5.1": 0.503216,
			"6.1": 0.04493,
			"7.1": 0.026958,
			"9.1": 0.332482
		},
		"ios_saf": {
			"8": 0,
			"10": 1.21807894005,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0328258179642,
			"8.1-8.4": 0.0606443077644,
			"9.0-9.2": 0.0289312293922,
			"9.3": 0.441386704829
		},
		"android": {
			"3": 0,
			"4": 0.0154829328165,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00193536660207,
			"4.1": 0.0558491505168,
			"4.2-4.3": 0.139622876292,
			"4.4": 0.320164932171,
			"4.4.3-4.4.4": 0.322929741602
		},
		"ie": {
			"6": 0.00980472444444,
			"7": 0.0392188977778,
			"8": 1.19617638222,
			"9": 0.578478742222,
			"10": 0.97066772,
			"11": 1.60797480889,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0810366251614,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00225101736559
		},
		"edge": {
			"12": 0.035944,
			"13": 0.13479,
			"14": 0.305524
		},
		"ie_mob": {
			"10": 0.0355548732394,
			"11": 0.144759126761
		},
		"bb": {
			"7": 0.00430525,
			"10": null
		},
		"samsung": {
			"0": 0.442681
		},
		"and_uc": {
			"0": 0.462941
		},
		"op_mini": {
			"0": 1.09179235747
		},
		"and_chr": {
			"0": 5.529032
		},
		"and_ff": {
			"0": 0.008104
		}
	},
	"total": 91.1697145256
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/UA.json
 ** module id = 670
 ** module chunks = 0
 **/